import { render, staticRenderFns } from "./cardBillDetailVip.vue?vue&type=template&id=7b270d5e&"
import script from "./cardBillDetailVip.vue?vue&type=script&lang=js&"
export * from "./cardBillDetailVip.vue?vue&type=script&lang=js&"
import style0 from "./cardBillDetailVip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports